import * as Cesium from "cesium";

// Changes cursor to pointer when hovering an Entity, restores previous cursor on leave.
export function setupHoverCursor(viewer) {
  const { ScreenSpaceEventHandler, ScreenSpaceEventType, KeyboardEventModifier, Entity } = Cesium;

  const canvas = viewer.scene.canvas;

  let prevCursor = canvas.style.cursor || "";
  let pointerOn = false;

  const handler = new ScreenSpaceEventHandler(canvas);

  // one shared callback
  const onMove = (movement) => {
    const pos = movement.endPosition || movement.position;
    if (!pos) return;

    let pick;
    try {
      pick = viewer.scene.pick(pos);
    } catch {
      pick = null;
    }

    const ent = pick?.id instanceof Entity || pick?.object?.id instanceof Entity || pick?.primitive?.id instanceof Entity;

    if (ent && !pointerOn) {
      prevCursor = canvas.style.cursor;
      canvas.style.cursor = "pointer"; // show hand
      pointerOn = true;
    } else if (!ent && pointerOn) {
      canvas.style.cursor = prevCursor || ""; // restore
      pointerOn = false;
    }
  };

  // register for no-modifier + common modifiers
  handler.setInputAction(onMove, ScreenSpaceEventType.MOUSE_MOVE);
  handler.setInputAction(onMove, ScreenSpaceEventType.MOUSE_MOVE, KeyboardEventModifier.SHIFT);
  handler.setInputAction(onMove, ScreenSpaceEventType.MOUSE_MOVE, KeyboardEventModifier.CTRL);
  handler.setInputAction(onMove, ScreenSpaceEventType.MOUSE_MOVE, KeyboardEventModifier.ALT);

  return {
    handler,
    cleanup: () => {
      try {
        handler.destroy();
      } catch {}
      canvas.style.cursor = prevCursor || "";
    },
  };
}
